import { render } from "./Modelslist.vue?vue&type=template&id=97646f46"
import script from "./Modelslist.vue?vue&type=script&lang=js"
export * from "./Modelslist.vue?vue&type=script&lang=js"

import "./Modelslist.vue?vue&type=style&index=0&id=97646f46&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__